// eslint-disable-next-line no-undef
const { __, sprintf } = wp.i18n

const checkStringMatch = (originalString, checkString) => {
  if (!originalString) return false
  return checkString.startsWith(originalString)
}

const placeHit = (item, classes = 'g-col-12 g-col-md-4 g-col-lg-3') => {
  const { objectID, date, url, title, city, zipCode, images } = item

  return `
    <article class="feed-place-listing ${classes}">
        <a id="feed-place-url-${item.objectID}" href="${item.url}" title="${
    item.title
  }" class="feed-place-listing__wrapper gtm_place_feed_visible gtm_place_feed_clicks">
            ${
              item.images.cards
                ? '<img class="feed-place-listing__img" src="' +
                  item.images.cards +
                  '" alt="' +
                  item.title +
                  '">'
                : '<div class="feed-place-listing__img"></div>'
            }
            <div class="feed-place-listing__contents">
                <span class="feed-place-listing__title"
                >${item.title}</span>
                <span class="feed-place-listing__address"
                >
                ${item.zipCode ? item.zipCode : ''}${
    item.zipCode && item.city ? ', ' : ''
  }
                ${item.city ? item.city : ''}
                </span>
            </div>
        </a>
    </article>
  `
}

const placeButton = {}
placeButton.textContent = __('Display more places', 'vn')

export { placeHit, placeButton }
